module.exports = __webpack_public_path__ + "img/egas-logo-white.4796734a.png";